@if (firstLoad) {
  <div class="position-relative">
    <portal-loading-indicator [show]="timeout == null && loading"></portal-loading-indicator>
  </div>
} @else {
  <div class="position-relative">
    <portal-loading-indicator
      [indicatorStyle]="opaque ? 'opaque' : 'transparent'"
      [show]="loading && (onlyInitial() === false || firstLoad)"
    ></portal-loading-indicator>
    <ng-content></ng-content>
  </div>
}
